export var PaymentMethod;
(function (PaymentMethod) {
    PaymentMethod["BANK_TRANSFER"] = "BANK_TRANSFER";
    PaymentMethod["CASH"] = "CASH";
    PaymentMethod["SUMUP"] = "SUMUP";
})(PaymentMethod || (PaymentMethod = {}));
